export const environment = {
  production: false,
  refreshTokenName: 'refreshToken_test',
  accessTokenName: 'accessToken_test',
  API_URL: 'https://nagykun-portal-admin-api-test-e4ddbwf3hcb7d3gk.westeurope-01.azurewebsites.net/',
  WEB_URL: '',
  DOC_URL: '',
  EMAIL_SERVER_ACTIVE: true,
};
